import React, { useState } from "react";
import PropTypes from "prop-types";
import Toggle from 'react-toggle';
import 'react-toggle/style.css'; // ייבוא סגנונות

/* === עיצובי צבעים ורוחב/גובה =============================== */
const variants = {
  swtOutlineGray200_5: {
    offColor: "#CE0000", // צבע כשהסוויץ' כבוי
    onColor: "#CE0000",  // החליפי כאן את הצבע הירוק הקיים לצבע החדש שאת רוצה
    offHandleColor: "#CE0000",
    onHandleColor: "#CE0000", // ידית לבנה
  },
}
const sizes = {
  xs: { width: 36, height: 18 },
  sm: { width: 64, height: 32 },
};
/* =========================================================== */

/**
 * Switch “דק” – רכיב *controlled* בלבד
 */
export const Switch = ({
  checked = false,
  onCheckedChange,
  className,
  checkedIcon = null,
  uncheckedIcon = null,
  variant = "swtOutlineGray200_5",
  size = "xs",
}) => (
  <div className={className}>
    <Toggle
      checked={checked}
      onChange={(e) => onCheckedChange(e.target.checked)} // ← חשוב מאוד!
      icons={{ checked: checkedIcon, unchecked: uncheckedIcon }}
      aria-label="switch"
      {...variants[variant]}
      style={{ width: sizes[size].width, height: sizes[size].height }}
    />
  </div>
);


Switch.propTypes = {
  checked: PropTypes.bool,
  onCheckedChange: PropTypes.func,
  className: PropTypes.string,
  checkedIcon: PropTypes.node,
  uncheckedIcon: PropTypes.node,
  size: PropTypes.oneOf(["sm", "xs"]),
  variant: PropTypes.oneOf(["swtOutlineGray200_5"]),
};
